var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from "classnames";
import * as React from "react";
export default class PanelBar extends React.Component {
    render() {
        const _a = this.props, { prefixCls, className, children, mode, icon, onLeftClick } = _a, restProps = __rest(_a, ["prefixCls", "className", "children", "mode", "icon", "onLeftClick"]);
        return (<div {...restProps} className={classnames(className, prefixCls, `${prefixCls}-${mode}`)}>
        {icon && (<div className={`${prefixCls}-left`} onClick={onLeftClick}>
            {icon}
          </div>)}
        <div className={`${prefixCls}-title`}>{children}</div>
      </div>);
    }
}
PanelBar.defaultProps = {
    prefixCls: "pm-panel-bar",
    mode: "dark",
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onLeftClick: () => { },
};
